import { useState } from 'react';
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useStoreValues } from '../../Context/storeProvider';


function PopupModal({ visible, children, title, size, handleClose, backdrop, onClick }) {
  const { user_Roll } = useStoreValues()

  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);
  // modalclose = title == "Accounts List" ? closeButton : null
  return (
    <>
      {/* <Button variant="primary" onClick={handleShow}>
        Launch demo modal
      </Button> */}


      <Modal show={visible} onHide={handleClose} backdrop={backdrop} centered size={size} style={{backgroundColor:"rgba(0,0,0,.2)"}}>
        <Modal.Header closeButton={title == "Accounts List" ? false : true} className='d-flex justify-content-between'>
          <Modal.Title className='h6 text_master'>
            {title}
          </Modal.Title>
          {title == "Accounts List" ?
          <div> 
            {user_Roll !== "AdminClient" &&
              <button className='btn btn-master font_14' onClick={onClick}>
              Add Account<i class="ms-2 font_14 fas fa-plus"></i></button>
            }
          </div>
            :
            <></>
          }
        </Modal.Header>
        <Modal.Body>
          {children}
        </Modal.Body>
        {title == "Accounts List" ?
        <div className='d-flex justify-content-end p-3'>
          <button className='btn btn-master font_14' onClick={handleClose}>Close</button>
        </div>
          :
          <></>
        }
      </Modal>

    </>
  )
}

export default PopupModal